import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 40px;
  min-width: 400px;
  max-width: 480px;
  box-sizing: border-box;

  header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
    
    img {
      width: 64px;
      height: 64px;
    }

    span {
      color: ${ ({ theme }) => theme.colors.primary };
      font-size: 22px;
      font-weight: 700 !important;
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .alteration {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 16px;
      color: ${ ({ theme }) => theme.colors.primary };
    }

    .service-name {
      font-size: 16px;
      font-weight: 700;
    }

    .alteration-text {
      font-size: 16px;
    }

    .divider {
      width: 100%;
      height: 2px;
      background-color: ${ ({ theme }) => theme.colors.greyLight };
    }
  }
    
  @media screen and (max-width: 768px) {
    min-width: 200px;
  }
`